module.exports = __webpack_public_path__ + "img/loading.a591ac27.gif";